import jxWindowEngine from '@/JxControls/JxWindowManager/JxWindowEngine';
import jxWindowManager from '@/JxControls/JxWindowManager/JxWindowManager.jsx';
import topicGroupEngine from './DashboardComponents/YourNotesTab/YourNotesGroupManager/TopicGroupEngine';
import attachmentEngine from './DashboardComponents/AttachmentStrip/AttachmentEngine';
import quotaEngine from '@/services/engines/QuotaEngine';
import userStateEngine2 from '@/controllers/UserState/UserStateEngine2';
import yourDataEngine from './DashboardComponents/YourDataTab/YourDataEngine';
import calendarEngine from '@/CalendarWidget/Core/CalendarEngine';
import yourNoteEngine from '@/services/engines/YourNoteEngine';
import groupNodeEngine from './DashboardComponents/YourNotesTab/Engines/GroupNodeEngine';
import searchEngine from './DashboardComponents/YourSearchTab/Core/SearchEngine';
import searchQueryEngine from './DashboardComponents/YourSearchTab/Core/SearchQueryEngine';
import userEngine from '@/controllers/User/UserEngine';
import logEngine from '@/services/engines/log/LogEngine';
import errorEngine from '@/components/shared/ErrorSnack/ErrorEngine';
import templateEngine from './DashboardComponents/TemplateEngine/TemplateEngine';
import bodyEditorEngine from '@/BodyEditorWidget/Core/BodyEditorEngine';
import formConfigEngine from '@/Widgets/FormBuilderWidget/Core/FormConfigEngine';
import csCodeTemplateEngine from '@/Widgets/CsCodeGenWidget/Core/CsCodeTemplateEngine';
import csCodeGenConfigEngine from '@/Widgets/CsCodeGenWidget/Core/CsCodeGenConfigEngine';
import umlNotesEngine from '@/UmlWorkspace/Core/UmlNotesEngine.js';
import outputMsgEngine from '@/Widgets/OutputMsgWidget/Core/OutputMsgEngine.js';
import cardDataEngine from '@/Widgets/DataPainterWidget/Core/CardDataEngine';
import userTypeEngine from './DashboardComponents/UserDefinedTypes/UserTypeEngine';
import umlPreviewEngine from '@/UmlWorkspace/Core/Preview/UmlPreviewEngine';
import umlPkgLibEngine from '@/UmlWorkspace/UmlPkgLib/Core/UmlPkgLibEngine';
import fearGreedEngine from '@/Widgets/DataPainterWidget/CmcFearWidget/CmcFearEngine';
import cmcUsageEngine from '@/Widgets/DataPainterWidget/CmcUsageWidget/CmcUsageEngine';
import userSettingsEngine from '@/controllers/UserSettings/UserSettingsEngine';
import cmcAssetEngine from '@/Widgets/DataPainterWidget/CmcAssetWidget/CmcAssetEngine';
import jxNoteEngine from '@/JxControls/NoteWidget/JxNoteEngine';
import sma200Engine from '@/Widgets/DataPainterWidget/Sma200Widget/Sma200Engine';
import rollingRangeEngine from '@/Widgets/DataPainterWidget/RollingRangeWidget/RollingRangeEngine';
import atrEngine from '@/Widgets/DataPainterWidget/AtrWidget/AtrEngine';
import rsiEngine from '@/Widgets/DataPainterWidget/RsiWidget/RsiEngine';
import pnl3UnmatchedEngine from '@/Widgets/DataPainterWidget/Pnl3Widget/Pnl3UnmatchedEngine';
import pnl3BalanceEngine from '@/Widgets/DataPainterWidget/Pnl3Widget/Pnl3BalanceEngine';
import entityEngine from '@/Widgets/DataPainterWidget/EntityCard/EntityEngine';
import tibberPriceEngine from '@/Widgets/DataPainterWidget/TibberPrice/TibberPriceEngine';
import serviceOverviewEngine from '@/Widgets/DataPainterWidget/ServiceOverview/ServiceOverviewEngine';
import batteryEngine from '@/Widgets/DataPainterWidget/BatteryWidget/BatteryEngine';
import batStateEngine from '@/Widgets/DataPainterWidget/BatteryWidget/BatStateEngine';
import batSeqMasterEngine from '@/Widgets/DataPainterWidget/BatSeqWidget/BatSeqMasterEngine';
import batSeqDetailEngine from '@/Widgets/DataPainterWidget/BatSeqWidget/BatSeqDetailEngine';
import powerScheduleEngine from '@/Widgets/DataPainterWidget/PowerSchedule/PowerScheduleEngine';
import powerUsageEngine from '@/Widgets/DataPainterWidget/PowerUsageWidget/PowerUsageEngine';
import powerUsageMonthEngine from '@/Widgets/DataPainterWidget/PowerUsageMonthWidget/PowerUsageMonthEngine';
import plugVueEngine from '@/Widgets/DataPainterWidget/PlugVueWidget/PlugVueEngine';
import boardEngine from '@/Widgets/DataPainterWidget/BoardWidget/BoardEngine';
import notificationEngine from '@/services/engines/notification/NotificationEngine';

/**
 * Engines with a generic, auth-independent bootup() — called once at app mount, order-independent.
 * userSettingsEngine is excluded — it must bootup before the token fetch, see PageContent.
 */
export const bootEngines = [
    jxWindowEngine,
    jxWindowManager,
    jxNoteEngine,
    topicGroupEngine,
    attachmentEngine,
    quotaEngine,
    userStateEngine2,
    yourDataEngine,
    calendarEngine,
    yourNoteEngine,
    groupNodeEngine,
    searchEngine,
    searchQueryEngine,
    userEngine,
    logEngine,
    errorEngine,
    templateEngine,
    bodyEditorEngine,
    formConfigEngine,
    csCodeTemplateEngine,
    csCodeGenConfigEngine,
    umlNotesEngine,
    outputMsgEngine,
    cardDataEngine,
    userTypeEngine,
    umlPreviewEngine,
    umlPkgLibEngine,
    fearGreedEngine,
    cmcUsageEngine,
    cmcAssetEngine,
    sma200Engine,
    rollingRangeEngine,
    atrEngine,
    rsiEngine,

    pnl3UnmatchedEngine,
    pnl3BalanceEngine,
    entityEngine,
    tibberPriceEngine,
    serviceOverviewEngine,
    batteryEngine,
    batStateEngine,
    batSeqMasterEngine,
    batSeqDetailEngine,
    powerScheduleEngine,
    powerUsageEngine,
    powerUsageMonthEngine,
    plugVueEngine,
    boardEngine,
    notificationEngine,
];

/**
 * User/tab-dependent fetch methods — called once auth + SignalR connection is confirmed,
 * see PageContent.checkSignalR's Promise.all.
 */
export const bootFetchers = [
    () => jxWindowEngine.fetchGeo(),
    () => formConfigEngine.fetchAll(),
    () => userTypeEngine.fetch(),
    () => umlNotesEngine.fetchAll(),
    () => umlPreviewEngine.fetchAll(),
    () => umlPkgLibEngine.fetchAll(),
    () => fearGreedEngine.fetch(),
    () => cmcUsageEngine.fetch(),
    () => userStateEngine2.fetchAll(),
    () => userEngine.fetchUser(),
    () => userSettingsEngine.fetchSettings(),
    () => templateEngine.fetchAll(),
    () => bodyEditorEngine.fetchStyles(),
    () => cmcAssetEngine.fetch(),
    () => sma200Engine.fetch(),
    () => rollingRangeEngine.fetch(),
    () => atrEngine.fetch(),
    () => rsiEngine.fetch(),

    () => pnl3BalanceEngine.fetch(),

    () => entityEngine.fetch(),
    () => tibberPriceEngine.fetch(),
    () => serviceOverviewEngine.fetch(),
    () => batteryEngine.fetch(),
    () => batStateEngine.fetch(),
    () => batSeqMasterEngine.fetch(),
    () => batSeqDetailEngine.fetch(),
    () => powerScheduleEngine.fetch(),
    () => powerUsageEngine.fetch(),
    () => powerUsageMonthEngine.fetch(),
    () => plugVueEngine.fetchSections(),
    () => plugVueEngine.fetch(),
    () => boardEngine.fetchBoards(),
];

/**
 * Engines cleared on PageContent unmount — jxWindowEngine/jxWindowManager included even
 * though they're also in bootEngines; clear() is idempotent-safe, order doesn't matter.
 */
export const unmountEngines = [groupNodeEngine, userEngine, jxWindowEngine, jxWindowManager];
